import { useState } from "react";

export default function SubmitConfirm({
    setShowFinalConfirm,
    onConfirm // غيرنا الاسم هنا ليتطابق مع ممرره ملف Questions
}) {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            // بننادي الفانكشن اللي جاية من Questions.jsx
            // هي جواها الـ API والـ Success Modals
            await onConfirm();
            // ملحوظة: الـ setShowFinalConfirm(false) موجودة جوه الفانكشن في الـ Parent
        } catch (error) {
            console.error('Submission error:', error);
            setIsSubmitting(false);
        }
    };

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
                zIndex: 9999,
                backdropFilter: 'blur(6px)',
                animation: 'fadeIn 0.2s ease-out'
            }}
            onClick={() => !isSubmitting && setShowFinalConfirm(false)}
        >
            <div
                className="bg-white rounded-4 shadow-lg position-relative overflow-hidden"
                style={{
                    maxWidth: '560px',
                    width: '90%',
                    animation: 'scaleIn 0.3s ease-out'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Decorative Top Border */}
                <div
                    style={{
                        height: '6px',
                        background: 'var(--accent)'
                    }}
                />

                {/* Header Section */}
                <div className="text-center pt-5 pb-4 px-4">
                    {/* Icon Container */}
                    <div
                        className="d-inline-flex align-items-center justify-content-center mb-4 position-relative"
                        style={{
                            width: '90px',
                            height: '90px'
                        }}
                    >
                        {/* Pulsing Background */}
                        <div
                            className="position-absolute"
                            style={{
                                width: '100%',
                                height: '100%',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(199, 29, 150, 0.1)',
                                animation: 'pulse 2s ease-in-out infinite'
                            }}
                        />
                        {/* Main Circle */}
                        <div
                            className="position-relative d-flex align-items-center justify-content-center"
                            style={{
                                width: '75px',
                                height: '75px',
                                borderRadius: '50%',
                                background: 'var(--accent)',
                                boxShadow: '0 8px 24px rgba(199, 29, 150, 0.3)'
                            }}
                        >
                            <i className="fas fa-check-circle" style={{ fontSize: '2.5rem', color: 'white' }}></i>
                        </div>
                    </div>

                    {/* Title */}
                    <h3
                        className="mb-3"
                        style={{
                            color: 'var(--ink)',
                            fontWeight: '700',
                            fontSize: '1.5rem',
                            letterSpacing: '-0.5px'
                        }}
                    >
                        Ready to Submit?
                    </h3>

                    {/* Description */}
                    <p
                        className="mb-2"
                        style={{
                            color: 'var(--ink-soft)',
                            fontSize: '1rem',
                            lineHeight: '1.6',
                            maxWidth: '420px',
                            margin: '0 auto'
                        }}
                    >
                        Once you submit this questionnaire, you will not be able to make any additional changes or updates.
                    </p>
                </div>

                {/* Warning Box */}
                <div
                    className="mx-4 mb-4 p-3 rounded-3"
                    style={{
                        backgroundColor: 'var(--accent-soft)',
                        border: '1px solid var(--hairline)',
                        borderLeft: '4px solid var(--accent)'
                    }}
                >
                    <div className="d-flex align-items-start">
                        <i
                            className="fas fa-exclamation-triangle me-3 mt-1"
                            style={{ color: 'var(--accent)', fontSize: '1rem' }}
                        ></i>
                        <div>
                            <strong
                                className="d-block mb-1"
                                style={{ color: 'var(--ink)', fontSize: '0.9rem' }}
                            >
                                This action is final
                            </strong>
                            <small style={{ color: 'var(--ink-soft)', lineHeight: '1.5' }}>
                                Please review your responses carefully before proceeding. You won't be able to edit them after submission.
                            </small>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div
                    className="p-4 border-top d-flex gap-3 justify-content-center"
                    style={{
                        backgroundColor: 'var(--surface-sunken)',
                        borderColor: 'var(--hairline)'
                    }}
                >
                    <button
                        type="button"
                        className="btn px-5 py-2 fw-semibold"
                        style={{
                            borderRadius: '8px',
                            border: '2px solid var(--hairline)',
                            color: 'var(--ink)',
                            backgroundColor: 'white',
                            minWidth: '140px',
                            transition: 'all 0.2s ease'
                        }}
                        onClick={() => setShowFinalConfirm(false)}
                        disabled={isSubmitting}
                    >
                        <i className="fas fa-times me-2"></i>
                        Cancel
                    </button>

                    <button
                        type="button"
                        className="btn px-5 py-2 fw-semibold shadow-sm"
                        style={{
                            borderRadius: '8px',
                            backgroundColor: isSubmitting ? 'var(--accent-strong)' : 'var(--accent)',
                            color: 'white',
                            border: 'none',
                            minWidth: '140px',
                            transition: 'all 0.2s ease',
                            position: 'relative'
                        }}
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Submitting...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-paper-plane me-2"></i>
                                Confirm Submit
                            </>
                        )}
                    </button>
                </div>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }
                
                @keyframes scaleIn {
                    from { opacity: 0; transform: scale(0.9); }
                    to { opacity: 1; transform: scale(1); }
                }
                
                @keyframes pulse {
                    0%, 100% { transform: scale(1); opacity: 0.3; }
                    50% { transform: scale(1.1); opacity: 0.1; }
                }
            `}} />
        </div>
    );
}